import React, {FC, PropsWithChildren, createContext, useMemo} from 'react';

import {ErrorLayoutType} from 'common/constants';
import {System} from 'common/models/system';

import ErrorPage from '../components/Error';
import {selectors, useAppSelector} from '../store';

interface ErrorContextProviderProps {
    error?: System['error'];
}

const {selectError} = selectors;

export const ErrorContext = createContext<ErrorLayoutType | null>(null);

export const ErrorContextProvider: FC<PropsWithChildren<ErrorContextProviderProps>> = (props) => {
    const storeError = useAppSelector(selectError);

    const error = useMemo(() => props.error || storeError, [props.error, storeError]);

    return (
        <ErrorContext.Provider value={error}>
            {error ? <ErrorPage error={error} /> : props.children}
        </ErrorContext.Provider>
    );
};
